import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Gastos from "./pages/Gastos";
import Habitaciones from "./pages/Habitaciones";
import Usuarios from "./pages/Usuarios";
import Perfil from "./pages/Perfil";
import ResumenUsuario from "./pages/ResumenUsuario";
import RentaAnual from "./pages/RentaAnual";

function App() {
    return (
        <AuthProvider>
            <Router>
                <div className="App">
                    <AppRoutes />
                </div>
            </Router>
        </AuthProvider>
    );
}

function AppRoutes() {
    const { user } = useAuth();

    if (!user) {
        return (
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        );
    }

    return (
        <>
            <Navbar />
            <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/gastos" element={<Gastos />} />
                <Route path="/habitaciones" element={<Habitaciones />} />
                {user.tipo_usuario === "gestor" && (
                    <>
                        <Route path="/usuarios" element={<Usuarios />} />
                        <Route path="/resumen-usuario/:id" element={<ResumenUsuario />} />
                        <Route path="/renta-anual" element={<RentaAnual />} />
                    </>
                )}
                <Route path="/perfil" element={<Perfil />} />
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </>
    );
}

export default App;
